import React from 'react';
import styles from './ViewGatePassModal.module.css';
import Cookies from 'js-cookie';
import { convertToAmPmRange, getExpectedArrivalTime } from './GatePassRequestTable';
import { convertTo24Hour } from './customFunction';
import { formatDateDashToAlpha } from 'utils/formatDateDashToAlpha';
import { typeResolve } from './GateRequestSuccessModal';
import useDisableBodyScroll from 'hooks/useDisableBodyScroll';

const statusToClass = (status) => {
  const key = (status || '').toString().toLowerCase();
  if (key.includes('pend')) return styles.statusPending;
  if (key.includes('approv')) return styles.statusApproved;
  if (key.includes('reject')) return styles.statusRejected;
  return styles.statusDefault;
};

export const formatDate2 = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const formatted = `${day}-${monthNames[parseInt(month) - 1]}-${year}`;
  return formatted;
};
function to24Display(timeStr) {
  if (!timeStr) return '';
  const raw = String(timeStr).trim();
  if (raw === '24:00') return '24:00';
  const converted = convertTo24Hour(raw);
  return converted === '00:00' ? '24:00' : converted;
}

const formatDate = (value) => {
  if (!value) return 'Not Available (N/A)';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  } catch (e) {
    return value;
  }
};

const ViewGatePassModal = ({ open, onClose, data = {} }) => {
  // Prevent background scrolling when modal is open
  useDisableBodyScroll(open);

  // console.log('ViewGatePassModal data:', data);
  if (!open) return null;
  // console.log('view etails -->><', data);
  const { requestId, requestType, status, reason, submittedAt, remark, duration = {} } = data || {};

  const encodedUser = Cookies.get('user') || '';
  const decodedUser = decodeURIComponent(encodedUser);

  const parsedUser = JSON.parse(decodedUser);

  const displayDate = formatDate2(duration?.date);
  const displayTime = duration?.time || (duration?.fromTime && duration?.toTime ? `${duration.fromTime} - ${duration.toTime}` : '');

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Request Details</h3>
          <button type="button" className={styles.closeBtn} aria-label="Close" onClick={onClose}>
            <span className={styles.closeIcon}>×</span>
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.row}>
            <div className={styles.colLabel}>Student Name:</div>
            <div className={styles.colValue}>{parsedUser ? `${parsedUser.firstName} ${parsedUser.lastName}` : 'Not Available(N/A)'}</div>
            <div className={styles.colLabel}>Status:</div>
            <div className={styles.colValue}>
              <span className={`${styles.statusPill} ${statusToClass(status)}`}>{status || 'Not Available(N/A)'}</span>
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.colLabel}>Request ID:</div>
            <div className={styles.colValue}>{requestId || 'Not Available(N/A)'}</div>
            <div className={styles.colLabel}>Student UID:</div>
            <div className={styles.colValue}>
              <div className={styles.colValue}>{parsedUser ? `${parsedUser.UID}` : 'Not Available(N/A)'}</div>
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.colLabel}>Request Type:</div>
            <div className={styles.colValue}>{typeResolve(requestType) || 'Not Available(N/A)'}</div>
            {remark && status.toLowerCase() === 'rejected' && (
              <>
                <div className={styles.colLabel}>Remark</div>
                <div className={styles.colValue}>{remark || 'Not Available(N/A)'}</div>
              </>
            )}
          </div>

          <div className={styles.row}>
            <div className={styles.colLabel}>Duration:</div>

            <div className={styles.colValue}>
              {/* Always show From Date */}
              <span className={styles.dateText}>
                {displayDate}
                <br />
              </span>

              {/* 🟣 Show TIME only for late_entry / early_departure */}
              {(data.requestTypeOriginal === 'late_entry' || data.requestTypeOriginal === 'early_departure') && data.toTime && (
                <span className={styles.timeText}>{to24Display(data.toTime)}</span>
              )}

              {/* 🟢 Show TO DATE only for leave */}
              {data.requestTypeOriginal === 'leave' && duration.toDate && (
                <span className={styles.timeText}>to {formatDate2(duration.toDate)}</span>
              )}
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.colLabel}>Reason:</div>
            <div className={styles.colValue}>{reason || 'Not Available(N/A)'}</div>
          </div>

          <div className={styles.row}>
            <div className={styles.colLabel}>Submitted Date:</div>
            <div className={styles.colValue}>{formatDateDashToAlpha(formatDate(submittedAt))}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGatePassModal;
